export default (...validators) => value =>
  validators.reduce((error, validator) => error || validator(value), undefined);

export const isRequired = (value) => (value ? undefined : 'Required');

export const isValidUrl = (value) => {
  if (value === undefined) return;
  return /^((http|https):\/\/)?[a-z0-9]+([\-\.]{1}[a-z0-9]+)*\.[a-z]{2,5}(:[0-9]{1,5})?(\/.*)?$/.test(value) ? undefined : "Must be a valid url";
}



// WEBPACK FOOTER //
// ./app/javascript/client/editor-ui/utils/validation.js